import React, { useEffect, useState } from "react";
import Select from "react-select";
import ShippingDetailsTab from "./Freight/ShippingDetailsTab";
import RoutingTab from "./Freight/RoutingTab";
import Main from "./Invoice/Main";
import ProfitLossTab from "./Charges/ProfileLossTab";
import Supplier from "./Invoice/Supplier";
import RelSVB from "./Invoice/RelSVB";
import Other from "./Invoice/Other";
import OtherDetails from "./Invoice/OtherDetails";
import Value from "./Invoice/Value";
import AddInvoice from "./AddEdit/AddInvoice";
import EditInvoice from "./AddEdit/EditInvoice";
import QuickEntry from "./AddEdit/QuickEntry";

const InvoiceTab = () => {
    const [showAdd, setShowAdd] = useState(false);
    const handleCloseAdd = () => setShowAdd(false);
    const handleShowAdd = () => setShowAdd(true);
  
    const [showEdit, setShowEdit] = useState(false);
    const handleCloseEdit = () => setShowEdit(false);
    const handleShowEdit = () => setShowEdit(true);

    const [showEntry, setShowEntry] = useState(false);
    const handleCloseEntry = () => setShowEntry(false);
    const handleShowEntry = () => setShowEntry(true);

  return (
    <>
      <div className="row">
        <div className="col-md-8">
          <div className="row-gap-2">
            <ul
              className="nav nav-pills mb-3 custom-tabs gap-0"
              id="pills-tab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="Estimates-charges-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#Estimates-charges-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="Estimates-charges-tab-pane"
                  aria-selected="false"
                >
                  Main
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="other-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#other-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="other-tab-pane"
                  aria-selected="false"
                >
                  Other Charges
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="supplier-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#supplier-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="supplier-tab-pane"
                  aria-selected="false"
                >
                  Supplier/Seller details
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="RelSVB-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#RelSVB-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="RelSVB-tab-pane"
                  aria-selected="false"
                >
                  Rel. & SVB details
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="OtherDetails-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#OtherDetails-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="OtherDetails-tab-pane"
                  aria-selected="false"
                >
                  Other details
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="Value-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#Value-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="Value-tab-pane"
                  aria-selected="false"
                >
                  Value totals
                </button>
              </li>
            </ul>
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="Estimates-charges-tab-pane"
                role="tabpanel"
                aria-labelledby="Estimates-charges-tab"
                tabIndex="0"
              >
                <Main />
              </div>
              <div
                className="tab-pane fade"
                id="other-tab-pane"
                role="tabpanel"
                aria-labelledby="other-tab"
                tabIndex="0"
              >
                <Other />
              </div>
              <div
                className="tab-pane fade"
                id="supplier-tab-pane"
                role="tabpanel"
                aria-labelledby="supplier-tab"
                tabIndex="0"
              >
                <Supplier />
              </div>
              <div
                className="tab-pane fade"
                id="RelSVB-tab-pane"
                role="tabpanel"
                aria-labelledby="RelSVB-tab"
                tabIndex="0"
              >
                <RelSVB/>
              </div>
              <div
                className="tab-pane fade"
                id="OtherDetails-tab-pane"
                role="tabpanel"
                aria-labelledby="OtherDetails-tab"
                tabIndex="0"
              >
                <OtherDetails />
              </div>
              <div
                className="tab-pane fade"
                id="Value-tab-pane"
                role="tabpanel"
                aria-labelledby="Value-tab"
                tabIndex="0"
              >
                <Value />
              </div>
            </div>
            <div className="d-flex flex-wrap gap-2 mt-2 pb-2" style={{borderBottom:"1px solid #d4d4d4"}}>
                        <button className="btn btn-primary text-xs" type="submit" onClick={handleShowAdd}>
                            New
                        </button>
                        <button className="btn btn-primary text-xs" type="submit" onClick={handleShowEdit}>
                            Edit
                        </button>
                        <button className="btn btn-primary text-xs" type="submit">
                            Update
                        </button>
                        <button className="btn btn-primary text-xs" type="submit">
                            Delete
                        </button>
                        <button className="btn btn-primary text-xs" type="submit">
                            Copy
                        </button>
                        <button className="btn btn-primary text-xs" type="submit">
                            Refresh
                        </button>
                        <button className="btn btn-primary text-xs" type="submit">
                            Move Up
                        </button>
                        <button className="btn btn-primary text-xs" type="submit">
                            Move Down
                        </button>
                        <button className="btn btn-primary text-xs" type="submit">
                            Copy Info
                        </button>
                        <button className="btn btn-primary text-xs" type="submit"  onClick={handleShowEntry}>
                            Quick Entry
                        </button>
                        <button className="btn btn-primary text-xs" type="submit">
                            View Products
                        </button>
                        <button className="btn btn-primary text-xs" type="submit">
                            Bulk Updation
                        </button>
                    </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card">
            <div className="card-header">Total</div>
            <div className="card-body">
              <div className="d-flex mt-2 gap-3">
                <label htmlFor="pickuptype" className="form-label w-100 ">
                  Product Value:
                </label>
                <input
                  type="text"
                  name=""
                  id=""
                  className="form-control form-control-sm"
                  disabled
                />
              </div>
            </div>
          </div>
          <div className="card mt-1">
            <div className="card-header">Current Invoice Details</div>
            <div className="card-body">
              <div className="d-flex mt-2 gap-3">
                <label htmlFor="pickuptype" className="form-label w-100 ">
                Invoice Number:
                </label>
                <input
                  type="text"
                  name=""
                  id=""
                  className="form-control form-control-sm"
                  disabled
                />
              </div>
              <div className="d-flex mt-2 gap-3">
                <label htmlFor="pickuptype" className="form-label w-100 ">
                Date:
                </label>
                <input
                  type="text"
                  name=""
                  id=""
                  className="form-control form-control-sm"
                  disabled
                />
              </div>
              <div className="d-flex mt-2 gap-3">
                <label htmlFor="pickuptype" className="form-label w-100 ">
                TOI:
                </label>
                <input
                  type="text"
                  name=""
                  id=""
                  className="form-control form-control-sm"
                  disabled
                />
              </div>
              <div className="d-flex mt-2 gap-3">
                <label htmlFor="pickuptype" className="form-label w-100 ">
                Currency:
                </label>
                <input
                  type="text"
                  name=""
                  id=""
                  className="form-control form-control-sm"
                  disabled
                />
              </div>
              <div className="d-flex mt-2 gap-3">
                <label htmlFor="pickuptype" className="form-label w-100 ">
                Exchange Rate:
                </label>
                <input
                  type="text"
                  name=""
                  id=""
                  className="form-control form-control-sm"
                  disabled
                />
              </div>
              <div className="d-flex mt-2 gap-3">
                <label htmlFor="pickuptype" className="form-label w-100 ">
                Product Value:
                </label>
                <input
                  type="text"
                  name=""
                  id=""
                  className="form-control form-control-sm"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <AddInvoice showAdd={showAdd} handleCloseAdd={handleCloseAdd} />
      <EditInvoice showAdd={showEdit} handleCloseAdd={handleCloseEdit} />
      <QuickEntry showAdd={showEntry} handleCloseAdd={handleCloseEntry} />
    </>
  );
};

export default InvoiceTab;
